import React from 'react';
import CanvasNode from './CanvasNode';
import styles from './CanvasArea.module.css';

const NODE_W = 200;
const NODE_H = 80;

function bezierPath(x1, y1, x2, y2) {
  const dx = 0;
  const dy = Math.abs(y2 - y1) * 0.5;
  return `M${x1},${y1} C${x1 + dx},${y1 + dy} ${x2 - dx},${y2 - dy} ${x2},${y2}`;
}

class CanvasArea extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.handleCanvasClick = this.handleCanvasClick.bind(this);
  }

  _nodeCenter(node) {
    return {
      top:    { x: node.x + NODE_W / 2, y: node.y },
      bottom: { x: node.x + NODE_W / 2, y: node.y + NODE_H },
    };
  }

  handleCanvasClick(e) {
    if (e.target === this.canvasRef.current || e.target === this.canvasRef.current?.querySelector('.' + styles.svgOverlay)) {
      this.props.onDeselect && this.props.onDeselect();
    }
  }

  render() {
    const { nodes, edges, selectedId, onSelect, onMove, onDelete } = this.props;

    return (
      <div
        ref={this.canvasRef}
        className={styles.canvas}
        onClick={this.handleCanvasClick}
      >
        {/* SVG connections */}
        <svg className={styles.svgOverlay}>
          <defs>
            <marker id="arrowhead" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
              <polygon points="0 0, 8 3, 0 6" fill="var(--b2)" />
            </marker>
          </defs>
          {(edges || []).map(edge => {
            const from = nodes.find(n => n.id === edge.from);
            const to   = nodes.find(n => n.id === edge.to);
            if (!from || !to) return null;
            const a = this._nodeCenter(from).bottom;
            const b = this._nodeCenter(to).top;
            return (
              <path
                key={edge.id}
                d={bezierPath(a.x, a.y, b.x, b.y)}
                fill="none"
                stroke="var(--b2)"
                strokeWidth="1.5"
                strokeDasharray="none"
                markerEnd="url(#arrowhead)"
              />
            );
          })}
        </svg>

        {/* Nodes */}
        {nodes.map(node => (
          <CanvasNode
            key={node.id}
            node={node}
            selected={node.id === selectedId}
            onSelect={onSelect}
            onMove={onMove}
            onDelete={onDelete}
          />
        ))}

        {nodes.length === 0 && (
          <div className={styles.empty}>
            <div className={styles.emptyIco}>
            <span className="material-symbols-rounded" style={{ fontSize: 40 }}>route</span>
          </div>
            <div className={styles.emptyTitle}>Canvas is empty</div>
            <div className={styles.emptySub}>Drag nodes from the left palette to start building your journey</div>
          </div>
        )}
      </div>
    );
  }
}

export default CanvasArea;
